import { useEffect } from "react";
import { FaCircleCheck } from "react-icons/fa6";
import { LuUserRound } from "react-icons/lu";
import { LuCheck } from "react-icons/lu";
import {
    UserOutlined, LoadingOutlined, LockOutlined
} from '@ant-design/icons';
import { Button, Modal, Spin } from 'antd';


export default function BankDetailsStep({ data, setData, setPrefillBankData, setBankData,
    setIsBankValid,
    isBankValid,
    isBankVerified,
    loading, bankData, bankSuccess, prefillBankData }) {

    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     const updatedData = {
    //         ...data,
    //         [name]: value
    //     };
    //     setData(updatedData);
    //     const isValid =
    //         updatedData.name &&
    //         updatedData.accountnumber &&
    //         updatedData.ifsc;
    //     setBankData(!!isValid);

    //     setData({
    //         ...data,
    //         [name]: value
    //     });
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;

        const updatedData = {
            ...data,
            [name]: value
        };

        setData(updatedData);

        const isValid =
            updatedData.name &&
            updatedData.accountnumber &&
            updatedData.ifsc;

        setIsBankValid(!!isValid);

        console.log("Updated Bank Data ----->:", updatedData);
        console.log("Updated IsValid --------->:", isValid);
    };

    useEffect(() => {
        if (prefillBankData && !data?.accountnumber) {
            setData({
                ...data,
                accountnumber: prefillBankData?.accountnumber || "",
                ifsc: prefillBankData?.ifsc || "",
                name: prefillBankData?.name || "",
                bankname: prefillBankData?.bank_name || "",
                branchname: prefillBankData?.branch_name || "",
            });
        }
    }, [prefillBankData]);

    return (
        <div>
            <h2 className="h4 mt-5 fw-semibold text-dark mb-0 px-0 pt-0 pb-4" style={{ color: "black", fontSize: "20px", fontWeight: "600" }}>
                Enter Bank Details

            </h2>
            <div className="card shadow-sm p-4 border-0 mt-1" style={{ borderRadius: "16px" }}>
                {isBankVerified && (
                    <div className="alert mb-3 alert-success mb-0 p-2" style={{ color: "green" }}>
                        <FaCircleCheck /> Your Bank Details is verified successfully.
                    </div>
                )}

                <div className="card-body p-0">
                    <h2 className="h4  fw-semibold text-dark mb-0 px-0 pt-0 pb-4 d-flex align-items-center" style={{ color: "black", fontSize: "20px", fontWeight: "600", gap: "5px" }}>
                        <UserOutlined />     Bank Details

                    </h2>
                    <div className="d-flex mt-3" style={{ gap: "18px" }}>
                        <div className="w-50">
                            <label>Account Holder Name *</label>
                            <div style={{ position: "relative" }}>
                                <input
                                    type="text"
                                    name="name"
                                    value={data.name || ""}
                                    onChange={handleChange}
                                    className="form-control pe-5"
                                    style={{ background: "#F3F3F5" }}
                                    readOnly={isBankVerified ? true : false}
                                />

                                {isBankVerified && (
                                    <LuCheck
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "green",
                                            fontSize: "18px"
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="w-50">
                            <label>IFSC Code *</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    name="ifsc"
                                    value={data.ifsc || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{ background: "#F3F3F5" }}
                                    readOnly={isBankVerified ? true : false}
                                />
                                {isBankVerified && (
                                    <LuCheck
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "green",
                                            fontSize: "18px"
                                        }}
                                    />
                                )}
                            </div>
                        </div>


                    </div>

                    <div className="d-flex mt-3" style={{ gap: "18px" }}>
                        <div className="w-50">
                            <label>Account Number *</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    name="accountnumber"
                                    value={data.accountnumber || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{ background: "#F3F3F5" }}
                                    readOnly={isBankVerified ? true : false}
                                />
                                {isBankVerified && (
                                    <LuCheck
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "green",
                                            fontSize: "18px"
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {!data?.isVerifiedBank ? <div className="w-50">
                            <label>Account Type *</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    name="accounttype"
                                    value={data.accounttype || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{ background: "#F3F3F5" }}
                                    readOnly={isBankVerified ? true : false}
                                />
                                {isBankVerified && (
                                    <LuCheck
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "green",
                                            fontSize: "18px"
                                        }}
                                    />
                                )}
                            </div>
                        </div> : null}


                    </div>

                    <div className="d-none" style={{ gap: "18px" }}>
                        <div className="mt-3 w-50">
                            <label>Bank Name *</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    name="bank_name"
                                    value={data.bankname || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                                {isBankVerified && (
                                    <LuCheck
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "green",
                                            fontSize: "18px"
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="mt-3 w-50">
                            <label>Branch Name *</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    name="branch_name"
                                    value={data.branchname || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                                {isBankVerified && (
                                    <LuCheck
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "green",
                                            fontSize: "18px"
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Modal
                open={loading}
                footer={null}
                closable={false}
                centered
                width={450}
                style={{ borderRadius: "20px" }}

            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p style={{ fontWeight: "600", fontSize: "20px" }} className="m-0">  Verifying your bank account...</p>
                    <p style={{ color: "gray" }} className="mt-1">this usually takes 2-3 secs</p>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: "orange" }} spin />} />
                    <p style={{ marginTop: "15px", gap: "10px", color: "gray" }} className="d-flex justify-content-center align-items-center">
                        <LockOutlined /> <span> Your details are securely processing. </span> </p>
                </div>
            </Modal>
        </div>
    );
}
